module.exports = __webpack_public_path__ + "static/media/europ.f7b7d6b3.svg";